export enum ServiceProviderType {
  HairAndBeauty = 0,
  ClothTailoringAndAlterations = 1,
  HandymanServices = 2,
  DomesticCareServices = 3,
  EventsAndEntertainment = 4,
  TransportServices = 5,
  CleaningServices = 6,
  SalesAndTrade = 7,
  ArtisanJobs = 8
}

export const serviceProviderTypeDescriptions = [
  {
    enumValue: ServiceProviderType.HairAndBeauty,
    description: 'Beauty and Hair Services'
  },
  {
    enumValue: ServiceProviderType.ClothTailoringAndAlterations,
    description: 'Cloth Tailoring and Alterations'
  },
  {
    enumValue: ServiceProviderType.HandymanServices,
    description: 'Handyman Services'
  },
  {
    enumValue: ServiceProviderType.DomesticCareServices,
    description: 'Domestic Care Services'
  },
  {
    enumValue: ServiceProviderType.EventsAndEntertainment,
    description: 'Events and Entertainment'
  },
  {
    enumValue: ServiceProviderType.TransportServices,
    description: 'Transport Services'
  },
  {
    enumValue: ServiceProviderType.CleaningServices,
    description: 'Cleaning Services'
  },
  {
    enumValue: ServiceProviderType.SalesAndTrade,
    description: 'Sales and Trade'
  },
  {
    enumValue: ServiceProviderType.ArtisanJobs,
    description: 'Artisan Jobs'
  }
];
